<template>
  <global-card
    v-if="user"
    :title="title"
    :with-actions="false"
    :heading-color="headingColor"
    :show-heading="showHeading"
    :fill-height="fillHeight"
  >
    <div
      class="d-flex flex-column align-center text-center"
      :class="{ 'mt-3': title }"
    >
      <user-avatar
        :zoom-enabled="zoomEnabled"
        :user="user"
        :size="xs ? '80' : '150'"
      />
      <div :class="xs ? 'text-body-large text-primary-darken-1' : 'text-headline-small'">
        {{ user.full_name }}
      </div>
      <div
        v-if="description"
        class="text-body-large text-primary-darken-1"
      >
        {{ description }}
      </div>

      <phone-number
        v-if="user.mobile_phone"
        :number="user.mobile_phone"
        :size="xs ? 'x-small' : 'small'"
      />

      <phone-number
        v-if="user.landline_phone"
        :number="user.landline_phone"
        icon="fas fa-phone"
        :size="xs ? 'x-small' : 'small'"
      />

      <v-btn
        v-if="showEmail"
        class="text-lowercase"
        :href="`mailto:${user.email}`"
        variant="plain"
        size="large"
        :text="user.email"
      >
        <template #prepend>
          <v-icon
            icon="fas fa-envelope"
            :size="xs ? 'x-small' : 'small'"
          />
        </template>
      </v-btn>
    </div>
  </global-card>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify';
import UserAvatar from '../images/UserAvatar.vue';

withDefaults(defineProps<{
  user: any;
  title?: string;
  headingColor?: string;
  description?: string;
  showEmail?: boolean;
  showHeading?: boolean;
  fillHeight?: boolean;
  zoomEnabled?: boolean;
}>(), {
  headingColor: () => 'primary',
  showEmail: () => true,
  showHeading: () => true,
  fillHeight: () => true,
  zoomEnabled: () => false,
});
const { xs } = useDisplay();
</script>
